import type { Product } from "@/contexts/product-context"
import {
  isStudentHomeSession,
  STUDENT_EXXAT_ONE_PRODUCT,
} from "@/lib/student-exxat-one-home"

export type StudentExxatOneTabId = "home" | "schedule" | "jobs"

export type StudentExxatOneTab = {
  id: StudentExxatOneTabId
  label: string
  href: string
  icon: string
}

/** Center tabs on the student Exxat One utility bar. */
export const STUDENT_EXXAT_ONE_TABS: readonly StudentExxatOneTab[] = [
  {
    id: "home",
    label: "Home",
    href: "/one-schools/home",
    icon: "fa-house",
  },
  {
    id: "schedule",
    label: "Schedule",
    href: "/one-schools/schedule",
    icon: "fa-calendar-days",
  },
  {
    id: "jobs",
    label: "Jobs",
    href: "/one-schools/jobs",
    icon: "fa-briefcase",
  },
]

export function studentExxatOneProductLandingPath(productSlug: string): string {
  return `/${productSlug}/home`
}

export function isStudentExxatOneShellPath(pathname: string): boolean {
  return STUDENT_EXXAT_ONE_TABS.some(
    tab => pathname === tab.href || pathname.startsWith(`${tab.href}/`),
  )
}

export function usesStudentExxatOneUtilityBar(
  product: Product,
  pathname: string,
): boolean {
  return (
    isStudentHomeSession() &&
    product === STUDENT_EXXAT_ONE_PRODUCT &&
    pathname.startsWith("/one-schools")
  )
}

export function studentExxatOneTabFromPath(pathname: string): StudentExxatOneTabId {
  if (pathname.includes("/schedule")) return "schedule"
  if (pathname.includes("/jobs")) return "jobs"
  return "home"
}

export function studentExxatOneDashboardHref(productSlug: string): string {
  return studentExxatOneProductLandingPath(productSlug)
}
